export default class BaseToDrawers {
    constructor() {
        this.init = this.init.bind(this);
        this.init();
    }
    async init() {
        try {
            await this.waitForPageLoad();
            await this.watchForBaseSelection();
            this.changeDrawerText();
        } catch (error) {
            console.error('Error waiting for page load', error);
        }
    }
    // Will wait for the add basket button to load.
    waitForPageLoad() {
        return new Promise((resolve, reject) => {
            const anchor = document.querySelector('article.product');
            if (!anchor) {
                reject('Anchor not found');
                return;
            }
            const observer = new MutationObserver((mutationsList, observer) => {
                for (const mutation of mutationsList) {
                    if (mutation.target.matches('.soap-product-selector')) {
                        observer.disconnect(); // Stop observing once the target is found
                        resolve(mutation); // Resolve the promise with the mutation data
                        return;
                    }
                }
            });
            observer.observe(anchor, { childList: true, subtree: true });
        });
    }

    changeDrawerText() {
        const filter = Array.from(document.querySelectorAll('.attribute-selector')).filter(f => {
            return f.querySelector('.soap-product-selector__dropdown__label') && f.querySelector('.soap-product-selector__dropdown__label').textContent.toLowerCase().includes('drawer options');
        });

        if (filter.length === 0) return;

        const drawer = filter[0];

        if (!drawer) return;

        const button = drawer.querySelector('.guide-modal-open');
        if (!button) return;

        button.textContent = 'Drawer Guide';

        const modal = document.querySelector(`#product-guide-${button.dataset.product_info}`);
        if (!modal) return;

        const h2 = modal.querySelector('h2');
        if (!h2) return;

        h2.textContent = 'Drawer Guide';
    }

    watchForBaseSelection() {
        return new Promise((resolve, reject) => {
            const baseSelector = document.querySelector('.soap-product-selector');
            if (!baseSelector) {
                reject('Base selector not found');
                return;
            }

            const observer = new MutationObserver((mutationsList, observer) => {
                for (const mutation of mutationsList) {
                    const filter = Array.from(document.querySelectorAll('.attribute-selector')).filter(f => {
                        return f.querySelector('.soap-product-selector__dropdown__label') && f.querySelector('.soap-product-selector__dropdown__label').textContent.toLowerCase().includes('drawer options');
                    });
                    if (filter.length > 0) {
                        observer.disconnect();
                        resolve(true);
                        return;
                    }
                }
            });
            observer.observe(baseSelector, { childList: true, subtree: true });
        });
    }
}

if (document.querySelector('article.product')) new BaseToDrawers();
